import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
// import { VRButton } from 'three/examples/jsm/webxr/VRButton.js';
import { Line2, LineGeometry, LineMaterial } from 'three-fatline';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'

const data = require('./params.json')
const parameters = data
// console.log(dataJSON.count)

/**
 * Base
 */
// Debug
const gui = new dat.GUI()
gui.close()

// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/**
 * Galaxy
 */
// const parameters = {
//     count: 151900,
//     size: 0.01,
//     radius: 6,
//     branches: 6,
//     spin: 1,
//     randomness: 0.4,
//     randomnessPower: 2.5,
//     insideColor: '#ff6030',
//     outsideColor: '#1b3984'
// }

let geometry = null
let material = null
let points = null

const group = new THREE.Group()
scene.add(group)

const generateGalaxy = () =>
{
    /**
     * Testing for pre-existing value
     */
    if(points !== null)
    {
        geometry.dispose()
        material.dispose()
        group.remove(points)
    }

    console.log('Generate the GALAXY')
    geometry = new THREE.BufferGeometry()
    const postitions = new Float32Array(parameters.count * 3)
    const colors = new Float32Array(parameters.count * 3)

    const colorInside = new THREE.Color(parameters.insideColor)
    const colorOutside = new THREE.Color(parameters.outsideColor)

    for(let i = 0; i < parameters.count; i++)
    {
        const i3 = i * 3

        // Position
        const radius = Math.random() * parameters.radius
        const spinAngle = radius * parameters.spin
        const branchAngle = (i % parameters.branches) / parameters.branches * Math.PI * 2

        const randomX = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : - 1)
        const randomY = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : - 1)
        const randomZ = Math.pow(Math.random(), parameters.randomnessPower) * (Math.random() < 0.5 ? 1 : - 1)

        postitions[i3] = Math.cos(branchAngle + spinAngle) * radius + randomX        // X coordinate
        postitions[i3 + 1] = randomY                                                 // Y coordinate
        postitions[i3 + 2] = Math.sin(branchAngle + spinAngle) * radius + randomZ    // Z coordinate

        // Color
        const mixedColor = colorInside.clone()
        mixedColor.lerp(colorOutside, radius / parameters.radius)

        colors[i3    ] = mixedColor.r
        colors[i3 + 1] = mixedColor.g
        colors[i3 + 2] = mixedColor.b
    }
    geometry.setAttribute('position', new THREE.BufferAttribute(postitions, 3))
    geometry.setAttribute('color', new THREE.BufferAttribute(colors, 3))
    
    /**
     * Material
     */
    material = new THREE.PointsMaterial({
        size: parameters.size,
        sizeAttenuation: true,
        depthWrite: false,
        blending: THREE.AdditiveBlending,
        vertexColors: true
    })

    /**
     * Points
     */
    points = new THREE.Points(geometry, material)

    group.add(points)
}

// function makeTextSprite( message, parameters )
//     {
//         if ( parameters === undefined ) parameters = {};
//         var fontface = parameters.hasOwnProperty("fontface") ? parameters["fontface"] : "Courier New";
//         var fontsize = parameters.hasOwnProperty("fontsize") ? parameters["fontsize"] : 18;
//         var borderThickness = parameters.hasOwnProperty("borderThickness") ? parameters["borderThickness"] : 4;
//         var borderColor = parameters.hasOwnProperty("borderColor") ?parameters["borderColor"] : { r:0, g:0, b:0, a:1.0 };
//         var backgroundColor = parameters.hasOwnProperty("backgroundColor") ?parameters["backgroundColor"] : { r:0, g:0, b:255, a:1.0 };
//         var textColor = parameters.hasOwnProperty("textColor") ?parameters["textColor"] : { r:0, g:0, b:0, a:1.0 };

//         var canvas = document.createElement('canvas');
//         var context = canvas.getContext('2d');
//         context.font = "Bold " + fontsize + "px " + fontface;
//         // context.font = fontsize + "px " + fontface;
//         var metrics = context.measureText( message );
//         canvas.width = 400;
//         canvas.height = 200;
//         // var textWidth = metrics.width + 10;
//         // console.log(textWidth)

//         context.fillStyle   = "rgba(" + backgroundColor.r + "," + backgroundColor.g + "," + backgroundColor.b + "," + backgroundColor.a + ")";
//         context.strokeStyle = "rgba(" + borderColor.r + "," + borderColor.g + "," + borderColor.b + "," + borderColor.a + ")";
//         context.fillStyle = "rgba("+textColor.r+", "+textColor.g+", "+textColor.b+", 1.0)";
//         context.fillText( message, borderThickness, fontsize + borderThickness);

//         var texture = new THREE.Texture(canvas) 
//         texture.generateMipmaps = false;
//         texture.needsUpdate = true;
//         var spriteMaterial = new THREE.SpriteMaterial( { map: texture } );
//         var sprite = new THREE.Sprite( spriteMaterial );
//         sprite.scale.set(0.5 * fontsize, 0.25 * fontsize, 0.75 * fontsize);
//         // sprite.scale.set(window.innerWidth/5, window.innerHeight/5, 1);
//         return sprite;  
//     }

generateGalaxy()

gui.add(parameters, 'count').min(100).max(1000000).step(100).onFinishChange(generateGalaxy)
gui.add(parameters, 'size').min(0.001).max(0.1).step(0.001).onFinishChange(generateGalaxy)
gui.add(parameters, 'radius').min(0.01).max(20).step(0.01).onFinishChange(generateGalaxy)
gui.add(parameters, 'branches').min(2).max(20).step(1).onFinishChange(generateGalaxy)
gui.add(parameters, 'spin').min(- 5).max(5).step(0.001).onFinishChange(generateGalaxy)
gui.add(parameters, 'randomness').min(0).max(2).step(0.001).onFinishChange(generateGalaxy)
gui.add(parameters, 'randomnessPower').min(1).max(10).step(0.001).onFinishChange(generateGalaxy)
gui.addColor(parameters, 'insideColor').onFinishChange(generateGalaxy)
gui.addColor(parameters, 'outsideColor').onFinishChange(generateGalaxy)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Situations
 */

const situationArray = [
    'Crying in the shower before work',
    'Feeling self-conscious about your haircut',
    'Still upset about how Game of Thrones ended',
    'Getting mad about being stuck in traffic'
]

/**
 * Textures
 */
 const textureLoader = new THREE.TextureLoader()
 const textMatcapTexture = textureLoader.load('textures/matcaps/9.png')
 
 // Material
 const textMaterial = new THREE.MeshMatcapMaterial({ matcap: textMatcapTexture })
//  const textMaterial = new THREE.MeshBasicMaterial({color: "white"})

/**
 * Fonts
 */
const fontLoader = new FontLoader()
const textGroup = new THREE.Group()
scene.add(textGroup)

// const spritey = makeTextSprite( "You Are Here", 
// { fontsize: 20, textColor: {r:255, g:255, b:255, a:1.0}} );
// spritey.position.set(0,0,0);
// textGroup.add( spritey );

// let script = situationArray[Math.floor(Math.random() * situationArray.length)]
// const spritey2 = makeTextSprite( script, 
// { fontsize: 12, textColor: {r:255, g:255, b:255, a:1.0}} );
// spritey2.position.set(0,0,0);
// textGroup.add( spritey2 );

fontLoader.load(
     '/fonts/helvetiker_regular.typeface.json',
     (font) =>
     {
         // Text
         let script = `You Are Here`
         const textGeometry = new TextGeometry(
             script,
             {
                 font: font,
                 size: 0.5,
                 height: 0.1,
                //  curveSegments: 12,
                //  bevelEnabled: true,
                //  bevelThickness: 0.03,
                //  bevelSize: 0.02,
                //  bevelOffset: 0,
                //  bevelSegments: 5
             }
         )
         textGeometry.center()
         const text = new THREE.Mesh(textGeometry, textMaterial)
        //  text.position.set(0, 3.5, 0)
         textGroup.add(text)
     }
 )
 fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) =>
    {
        // Text
        let script = situationArray[Math.floor(Math.random() * situationArray.length)]
        const textGeometry = new TextGeometry(
            script,
            {
                font: font,
                size: 0.2,
                height: 0.1,
                // curveSegments: 12,
                // bevelEnabled: true,
                // bevelThickness: 0.03,
                // bevelSize: 0.02,
                // bevelOffset: 0,
                // bevelSegments: 5
            }
        )
        textGeometry.center()
        const text = new THREE.Mesh(textGeometry, textMaterial)
        text.position.set(0, - 0.5, 0)
        textGroup.add(text)
    }
)
 textGroup.position.set(- 0.5, 3.5, 0)
//  textGroup.position.set(- 1, 3, 0)
 console.log(textGroup)
 
/**
 * Line test
 */
const lineGeometry = new LineGeometry();
lineGeometry.setPositions([- parameters.radius * 0.6, 0, 0, textGroup.position.x, textGroup.position.y - 0.75, textGroup.position.z]); // [ x1, y1, z1,  x2, y2, z2, ... ] format

const lineMaterial = new LineMaterial({
  color: 'white',
  linewidth: 2, // px
  resolution: new THREE.Vector2(sizes.width, sizes.height) // resolution of the viewport
  // dashed, dashScale, dashSize, gapSize
});

const myLine = new Line2(lineGeometry, lineMaterial);

myLine.computeLineDistances();
scene.add(myLine)

/**
 * Setting up viewport
 */
window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.x = 3
camera.position.y = 3
camera.position.z = 8
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// document.body.appendChild( VRButton.createButton( renderer ) );
// renderer.xr.enabled = true;

/**
 * Animate
 */
const clock = new THREE.Clock()

const tick = () =>
{
    const elapsedTime = clock.getElapsedTime()
    const rotationSpeed = elapsedTime * 0.08
    const centreLineDistance = parameters.radius * 0.6

    //Update Galaxy
    group.rotation.y = rotationSpeed

    // Update Line
    lineGeometry.setPositions
    (
        [
            Math.cos(- rotationSpeed) * centreLineDistance,
            0, 
            Math.sin(- rotationSpeed) * centreLineDistance,
            textGroup.position.x,
            textGroup.position.y - 0.75,
            textGroup.position.z
        ]
    )

    textGroup.lookAt(camera.position)

    // console.log(Math.cos(centreLineDistance) * 5)
    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()